export enum ARTICLE_TYPES {
  BLOG = 'Blog',
  HELP = 'Help',
}
